import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center">
              <i className="ri-bank-card-line text-white text-lg"></i>
            </div>
            <span className="text-xl font-bold text-gray-900">クレカ比較ナビ</span>
          </Link>
          
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/ranking" className="text-sm text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              ランキング
            </Link>
            <Link to="/comparison" className="text-sm text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              比較
            </Link>
            <Link to="/instant" className="text-sm text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              即日発行
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
